import type { MutableRefObject, Ref } from "react";
import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Merges multiple refs into a single callback ref. */
export function mergeRefs<T>(...refs: (Ref<T> | undefined)[]) {
  return (instance: T | null) => {
    refs.forEach((ref) => {
      if (typeof ref === "function") ref(instance);
      else if (ref) (ref as MutableRefObject<T | null>).current = instance;
    });
  };
}
